export const FADE_TIME = 1000;
